import { FormLabel } from "@mui/material";

export default function Label({ name, children, sx }) {
  return (
    <FormLabel
      htmlFor={name}
      sx={{
        color: "black",
        fontSize: "14px",
        fontWeight: 500,
        "> span": {
          color: "red",
        },
        ...sx,
      }}
    >
      {children}
    </FormLabel>
  );
}
